import { render, staticRenderFns } from "./ADMIN.vue?vue&type=template&id=499146f8&"
import script from "./ADMIN.vue?vue&type=script&lang=js&"
export * from "./ADMIN.vue?vue&type=script&lang=js&"
import style0 from "./ADMIN.vue?vue&type=style&index=0&id=499146f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports